import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface IBookingParams {
  passengerType?: string;
  cabinPrice?: string;
  adultPrice?: string;
  date: string;
  cruiseID?: string;
  cabinType?: string;
  categoryKey?: string;
  priceType?: string;
  priceCode?: string;
  discountCode?: string;
  promotionId?: string;
  adultsOccupancy?: number;
  childrenOccupancy?: number;
  infantOccupancy?: number;
  isFlightIncluded?: boolean;
  departureairportcode?: string;
  destinationairportcode?: string;
  departureairportname?: string;
  isDeal: boolean;
  mandatoryInsuranceCode?: string;
}

export interface IOccupancyParams {
  adultsOccupancy?: number;
  childrenOccupancy?: number;
  infantOccupancy?: number;
}

const initialState: IBookingParams = {
  cabinPrice: '',
  adultPrice: '',
  date: '',
  cruiseID: '',
  cabinType: '',
  categoryKey: '',
  priceType: '',
  priceCode: '',
  adultsOccupancy: 0,
  childrenOccupancy: 0,
  infantOccupancy: 0,
  isFlightIncluded: false,
  departureairportcode: '',
  destinationairportcode: '',
  isDeal: false,
  mandatoryInsuranceCode: '',
};

const bookingParamsSlice = createSlice({
  name: 'bookingParams',
  initialState,
  reducers: {
    setBookingParams: (state: IBookingParams, action: PayloadAction<IBookingParams>) => {
      state.passengerType = action.payload.passengerType;
      state.cabinPrice = action.payload.cabinPrice;
      state.adultPrice = action.payload.adultPrice;
      state.date = action.payload.date;
      state.cruiseID = action.payload.cruiseID;
      state.cabinType = action.payload.cabinType;
      state.categoryKey = action.payload.categoryKey;
      state.priceType = action.payload.priceType;
      state.priceCode = action.payload.priceCode;
      state.discountCode = action.payload.discountCode;
      state.promotionId = action.payload.promotionId;
      state.adultsOccupancy = action.payload.adultsOccupancy;
      state.childrenOccupancy = action.payload.childrenOccupancy;
      state.infantOccupancy = action.payload.infantOccupancy;
      state.isFlightIncluded = action.payload.isFlightIncluded;
      state.departureairportcode = action.payload.departureairportcode;
      state.destinationairportcode = action.payload.destinationairportcode;
      state.isDeal = action.payload.isDeal;
      state.departureairportname = action.payload.departureairportname;
      state.mandatoryInsuranceCode = action.payload.mandatoryInsuranceCode;
    },
    setOccupancy: (state: IBookingParams, action: PayloadAction<IOccupancyParams>) => {
      state.adultsOccupancy = action.payload.adultsOccupancy;
      state.childrenOccupancy = action.payload.childrenOccupancy;
      state.infantOccupancy = action.payload.infantOccupancy;
    },

    setDepartureAirportCode: (state: IBookingParams, action: PayloadAction<string>) => {
      state.departureairportcode = action.payload;
    },

    setDestinationAirportCode: (state: IBookingParams, action: PayloadAction<string>) => {
      state.destinationairportcode = action.payload;
    },
  },
});

export const {
  setBookingParams,
  setOccupancy,
  setDepartureAirportCode,
  setDestinationAirportCode,
} = bookingParamsSlice.actions;
export default bookingParamsSlice.reducer;
